module.exports = __webpack_public_path__ + "static/media/20180714_200700.fd2e8873.jpg";